import React from "react"
import Header from "../components/global/Header"
import Footer from "../components/global/Footer"
import logo from "../assets/images/pharmacylogo.png"
import address from "../assets/images/address.png"
import picture from "../assets/images/storepicture.png"
import contact from "../assets/images/contact.png"
import { Link } from "react-router-dom"
import StoreData from "../components/stores/StoreData"

export default function Pharmacy() {
  return (
    <div>
      <Header />
      <div className="container-fluid phmdashboard ">
        <div className="row pharmacy">
          <div className="col-lg-4">
            <div className="col-12 pharmacy__description">
              <img className="pharmacy__logo" src={logo} alt="" srcset="" />
              <p className="pharmacy__description__title">Bicycle Pharmacy</p>
              <p className="pharmacy__description__subtitle">We are a certified pharmacy providing you
                with all the drugs you need at your conveniency</p>
              <p className="pharmacy__description__address"> <img src={address} alt="" srcset="" /> <span>via Awolowo Road/Ijebu Bypass/Liebu Bypass and Ogunmola Street/A1</span></p>
              <span className="pharmacy__description__link">
                <img src={contact} alt="" />
                <Link>CONTACT US</Link>
              </span>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="col-12 pharmacy__picture">
              <img className="col-12" src={picture} alt="" srcset="" />
            </div>
          </div>
        </div>
        <div className="pharmacy__store">
          <p className="pharmacy__store__title"> FROM THE STORE</p>
          <p className="pharmacy__store__subtitle">Products from our store</p>
          <StoreData />
          <StoreData />
        </div>
      </div>
      <Footer />
    </div>
  )
}